// extracted by mini-css-extract-plugin
export default {"interview":"AU2XS","statistics":"tQB1g","list":"VsaK4","collections":"t5nbn"};